import { useEffect } from "react";
import { FiPlus, FiX } from "react-icons/fi";
import { shownTools, toolNamed, PRESETS } from "../../lib/tools/registry";
import { useToolPins, useShelf } from "./pins";
import { OPEN_TOOLS } from "./ToolLibrary";
import ToolPanel from "./ToolPanel";
import styles from "./tools.module.css";

// The shelf in Make (docs/refactor-plan.md, Phase 2), beside the Score and the Song: the tools you
// pinned, as tabs, with the open one's panel below; + finds more in the library. It's out when
// Make's Tools button says so, and remembers the tool you had open.
export default function Shelf() {
  const [shelf, change] = useShelf();
  // Out on a wide screen, the Score and the Song make room for it beside them (--site-shelf).
  useEffect(() => {
    document.documentElement.style.setProperty("--site-shelf", shelf.open ? "444px" : "0px");
    return () => document.documentElement.style.removeProperty("--site-shelf");
  }, [shelf.open]);
  // (Your pins load only once it's out.)
  return shelf.open ? <ShelfOut shelf={shelf} change={change} /> : null;
}

function ShelfOut({ shelf, change }) {
  const { pins, save } = useToolPins();
  const shown = new Set(shownTools().map((tool) => tool.id)), pinned = (pins || []).map(toolNamed).filter((tool) => tool && shown.has(tool.id));
  const current = pinned.find((tool) => tool.id === shelf.tool) || pinned[0] || null;
  useEffect(() => { if (current && current.id !== shelf.tool) change({ tool: current.id }); }, [current?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  return <aside className={styles.shelf} aria-label="Your tools">
    <div className={styles.shelfHead}>
      <h2>Your tools</h2>
      <button type="button" className={styles.button} onClick={() => window.dispatchEvent(new CustomEvent(OPEN_TOOLS))}>All tools <kbd>Ctrl K</kbd></button>
      <button type="button" className={styles.icon} aria-label="Put the tools away" onClick={() => change({ open: false })}><FiX aria-hidden="true" /></button>
    </div>
    {pins === null ? <div className={styles.presets} role="group" aria-label="Start your shelf">
      <span>Start your shelf for</span>
      {PRESETS.map((preset) => <button key={preset.id} type="button" className={styles.button} title={preset.says} onClick={() => save(preset.tools)}>{preset.label}</button>)}
    </div> : <div className={styles.shelfTabs} role="group" aria-label="Pinned tools">
      {pinned.map((tool) => <button key={tool.id} type="button" aria-pressed={tool.id === current?.id} onClick={() => change({ tool: tool.id })}>{tool.name}</button>)}
      <button type="button" aria-label="Find more tools" title="Find more tools (Ctrl+K)" onClick={() => window.dispatchEvent(new CustomEvent(OPEN_TOOLS))}><FiPlus aria-hidden="true" /></button>
    </div>}
    <div className={styles.shelfBody}>
      {current ? <ToolPanel tool={current} /> : pins !== null && <p className={styles.hint}>Pin tools from the library (Ctrl+K) and they sit here, ready for what you're making.</p>}
    </div>
  </aside>;
}
